function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.54688 11.875H12.4297L13.6016 8.125H4.71875L3.54688 11.875ZM8 13H3.5C2.67969 13 2 12.3203 2 11.5V4.75C2 3.92969 2.67969 3.25 3.5 3.25H6.75781C7.08594 3.25 7.39062 3.36719 7.64844 3.55469L8.5625 4.23438C8.67969 4.32812 8.84375 4.375 9.00781 4.375H11.75C12.5938 4.375 13.25 5.05469 13.25 5.875H12.125C12.125 5.66406 11.9609 5.5 11.75 5.5H9.00781C8.60938 5.5 8.21094 5.35938 7.88281 5.125L6.99219 4.44531C6.92188 4.39844 6.82812 4.375 6.75781 4.375H3.5C3.28906 4.375 3.125 4.53906 3.125 4.75V9.39062L3.64062 7.79688C3.78125 7.32812 4.22656 7 4.71875 7H13.6016C14.3516 7 14.9141 7.72656 14.6797 8.45312L13.5078 12.2031C13.3672 12.6719 12.9219 13 12.4297 13H8Z",
  fill: "#636766"
});

function SvgLibraryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library-icon.7581ee21.svg";
export { ForwardRef as ReactComponent };